import { IOccupancyDetails } from 'modules/lite/reservations/models';
import API from 'services/api';

interface IUpsertOccupancy {
  payload: IOccupancyDetails;
  unitOccupancyId: string | null;
  guestId: string | null;
}

export const upsertOccupancy = ({ payload, unitOccupancyId, guestId }: IUpsertOccupancy) => {
  if (!!unitOccupancyId) {
    return API.put(`/api/renter/accommodation/occupancies/${unitOccupancyId}`, payload);
  } else {
    if (!!guestId) {
      return API.post(`/api/renter/guests/${guestId}/occupancies`, payload);
    } else {
      return API.post('/api/renter/accommodation/occupancies', payload);
    }
  }
};

export const deleteOccupancyLite = (unitOccupancyId: string) =>
  API.delete(`/api/renter/accommodation/occupancies/${unitOccupancyId}`);
